// @flow

import {
  SET_VBMR_INITIALIZED,
  TOGGLE_VBMR_MODAL,
  OPEN_VBMR_MODAL,
  TOGGLE_VBMR,
  ACTIVATE_VBMR,
  SET_QUEUED_ACTIVES_DISPATCHERS,
  CLEAR_QUEUED_ACTIVES_DISPATCHERS,
  SET_VBMR_SECTION,
  INCREASE_ACTIVATE_MODAL_TIMES_TRIGGERED,
  INCREASE_DEACTIVATE_MODAL_TIMES_TRIGGERED,
  RESET_MODALS_TIMES_TRIGGERED,
} from './constants';

import type {
  VbmrState,
} from './types';

const initialState = {
  isActive: false,
  isInitialized: false,
  isShowingModal: false,
  modalType: null,
  queuedActivesDispatchers: null,
  section: '',
  activateModalTimesTriggered: 0,
  deactivateModalTimesTriggered: 0,
};

export default (
  state: VbmrState = initialState,
  action: { [index: string]: any },
): VbmrState => {
  switch (action.type) {
    case SET_VBMR_INITIALIZED:
      return {
        ...state,
        isInitialized: true,
      };
    case TOGGLE_VBMR_MODAL:
      return {
        ...state,
        isShowingModal: action.toggleState === OPEN_VBMR_MODAL,
        modalType: action.modalType,
      };
    case TOGGLE_VBMR:
      return {
        ...state,
        isActive: action.toggleState === ACTIVATE_VBMR,
      };
    case SET_QUEUED_ACTIVES_DISPATCHERS:
      return {
        ...state,
        queuedActivesDispatchers: action.queuedActivesDispatchers,
      };
    case CLEAR_QUEUED_ACTIVES_DISPATCHERS:
      return {
        ...state,
        queuedActivesDispatchers: null,
      };
    case SET_VBMR_SECTION:
      return {
        ...state,
        section: action.section,
      };
    case INCREASE_ACTIVATE_MODAL_TIMES_TRIGGERED:
      return {
        ...state,
        activateModalTimesTriggered: state.activateModalTimesTriggered + 1,
      };
    case INCREASE_DEACTIVATE_MODAL_TIMES_TRIGGERED:
      return {
        ...state,
        deactivateModalTimesTriggered: state.deactivateModalTimesTriggered + 1,
      };
    case RESET_MODALS_TIMES_TRIGGERED:
      return {
        ...state,
        activateModalTimesTriggered: 0,
        deactivateModalTimesTriggered: 0,
      };
    default:
      return state;
  }
};
